import { render, staticRenderFns } from "./DisableEmail.vue?vue&type=template&id=2b740b00&scoped=true&"
import script from "./DisableEmail.vue?vue&type=script&lang=js&"
export * from "./DisableEmail.vue?vue&type=script&lang=js&"
import style0 from "./DisableEmail.vue?vue&type=style&index=0&id=2b740b00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b740b00",
  null
  
)

export default component.exports